import Vue from 'vue'

export default () => {
  if (Object.prototype.hasOwnProperty.call(Vue.prototype, '$date')) {
    return
  }

  Object.defineProperty(Vue.prototype, '$date', {
    get () {
      return {
        format: (date, format) => {
          if (date === null) {
            return ''
          }

          if (typeof date === 'string') {
            date = new Date(date)
          }

          let char
          let out = ''
          const day = date.getDate()

          for (let i = 0; i < format.length; i++) {
            switch (format[i]) {
              // hours
              case 'a':
                // `am` or `pm`
                char = date.getHours() > 11 ? 'pm' : 'am'

                break

              case 'g':
                // `1` through `12`
                char = date.getHours()

                if (char === 0) {
                  char = 12
                } else if (char > 12) {
                  char -= 12
                }

                break

              case 'h':
                // `01` through `12`
                char = date.getHours()

                if (char === 0) {
                  char = 12
                } else if (char > 12) {
                  char -= 12
                }

                char = ('0' + char.toString()).slice(-2)

                break

              case 'A':
                // `AM` or `PM`
                char = date.getHours() > 11 ? 'PM' : 'AM'

                break

              case 'G':
                // `0` through `23`
                char = date.getHours()

                break

              case 'H':
                // `00` through `23`
                char = date.getHours()
                char = ('0' + char.toString()).slice(-2)

                break

              // minutes
              case 'i':
                // `00` through `59`
                char = date.getMinutes()

                if (char < 10) {
                  char = '0' + char
                }

                break

              // seconds
              case 's':
                // `00` through `59`
                char = ('0' + date.getSeconds().toString()).slice(-2)

                break

              // day
              case 'd':
                // `01` through `31`
                char = date.getDate()
                char = ('0' + char.toString()).slice(-2)

                break

              case 'j':
                // `1` through `31`
                char = date.getDate()

                break

              case 'S':
                char = ''

                if (day > 3 && day < 21) {
                  char = 'th'
                } else {
                  const chars = ['st', 'nd', 'rd']
                  char = chars[(day % 10) - 1] || 'th'
                }

                break

              // month
              case 'm':
                // `01` through `12`
                char = date.getMonth() + 1
                char = ('0' + char.toString()).slice(-2)

                break

              case 'M':
                // `Jan` through `Dec` (localized)
                char = this.$t('dashboard.global.date.month.' + date.getMonth())

                break

              case 'F':
                // `Jan` through `Dec` (localized)
                char = this.$t('dashboard.global.date.month_full.' + date.getMonth())

                break

              // year
              case 'Y':
                // Examples: `1988` or `2015`
                char = date.getFullYear()

                break

              // escape sequence
              case '\\':
                char = ''

                if (i + 1 < format.length) {
                  char = format[++i]
                }

                break

              default:
                char = format[i]

                break
            }

            out += char
          }

          return out
        },
        dateDiff: (date1, date2, type, weeks = false) => {
          const days = Math.floor(((date2 || new Date()) - date1) / (1000 * 3600 * 24))

          if (days < 0 && days > -7) {
            return this.$tc(`${type}.time_in.days`, Math.abs(days))
          }

          if (days >= 0 && days < 7) {
            return this.$tc(`${type}.time_ago.days`, days)
          }

          if (weeks) {
            const weeks = Math.floor(days / 7)

            if (weeks < 0 && weeks > -4) {
              return this.$tc(`${type}.time_in.weeks`, Math.abs(weeks))
            }

            if (weeks > 0 && weeks < 4) {
              return this.$tc(`${type}.time_ago.weeks`, weeks)
            }
          }

          const months = Math.floor(days / 31)

          if (months < 0 && months > -12) {
            return this.$tc(`${type}.time_in.months`, Math.abs(months))
          }

          if (months > 0 && months < 12) {
            return this.$tc(`${type}.time_ago.months`, months)
          }

          return this.$date.format(date1, this.$t('dashboard.dashboard.widgets.update-news.date_format'))
        }
      }
    }
  })
}
